import { userDtos } from '@vectronic/openApi-customer';

export const ANIMAL_GROUPS: userDtos.Group[] = [
  {
    id: 111111,
    name: 'AnimalGroup_1',
    label: 'label',
    membersIds: [11, 13],
    description: 'Description_AnimalGroup_1',
    role: 'OWNER',
  },
  {
    id: 111112,
    name: 'AnimalGroup_2',
    label: 'label',
    membersIds: [12, 13, 14],
    description: 'Description_AnimalGroup_2',
    role: 'OWNER',
  },
  {
    id: 111113,
    name: 'AnimalGroup_3',
    label: 'label',
    membersIds: [11, 13, 14],
    description: 'Description_AnimalGroup_3',
    role: 'OWNER',
  },
];
